import { render } from "./ManualUpload.vue?vue&type=template&id=eff68546"
import script from "./ManualUpload.vue?vue&type=script&lang=js"
export * from "./ManualUpload.vue?vue&type=script&lang=js"
script.render = render

export default script